import { toFixed } from 'humanize-plus'
import * as R from 'ramda'

/* KPI card helpers */
export const parseMetric = R.pipe(R.head, toFixed, parseInt)
